module.exports = __webpack_public_path__ + "img/PP_Sword_0036.d13d47c3.png";